import TriggerActionService from "../components/TriggerActionService";
import ActionTriggerConstants from "../components/ActionTriggerConstants";

const FirstTimeTrigger = {
  triggerLogic(sourceUrl = window.location.pathname) {
    TriggerActionService.sendTriggerAction(
      ActionTriggerConstants.FIRST_OPEN_TIME,
      "",
      { sourceUrl }
    ).catch((e) => console.warn("[FirstTimeTrigger] Trigger failed", e));
  }
};

export default FirstTimeTrigger;
